import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Alert, Button } from "@mui/material";
import moment from "moment-timezone";
import { useSchedulingOrg } from "../../../hooks/ReactQueryHooks/useSchedulingOrg";
import { useSchedulingTimeZone } from "../../../hooks/useSchedulingTimeZone";
import { useServiceCategoriesQuery } from "../../../hooks/ReactQueryHooks/useServiceCategoriesQuery";
import useOverviewPage from "./calendar/useOverviewPage";
import SchedulingCalendar from "./calendar/SchedulingCalendar";
import { buildCalendarEvents } from "./calendar/eventModel";
import ParentBadge from "./ParentBadge";

export default function SupplierAvailabilityModal({ supplier, name, organizationRef, organizationName, onHide }) {
  const { user, excludedOrganizationRefs } = useSchedulingOrg();
  const { timeZone } = useSchedulingTimeZone(user);
  const [date, setDate] = useState(moment.tz(timeZone).format("YYYY-MM-DD"));
  const start = moment.tz(date, timeZone).startOf("day");
  const query = useOverviewPage({ organizationRef, excludedOrganizationRefs, timezoneName: timeZone,
    startsAt: start.toISOString(), endsAt: start.clone().add(1, "day").toISOString(),
    overview: "details", practitionerRefs: [supplier.practitionerRef], limit: 1 });
  const { data: categories = [] } = useServiceCategoriesQuery({ organizationRef, scope: "own" });
  const data = query.data || {};
  const occupied = [...(data.blocks || []), ...(data.appointments || []).filter(a => ["booked", "proposed"].includes(a.status)).map(a => ({
    blockId: a.appointmentId, startsAt: a.startsAt, endsAt: a.endsAt, reasonCode: "Unavailable",
  }))];
  return <Modal show onHide={onHide} size="xl" centered className="custom-dialog scheduling-dialog">
    <Modal.Header closeButton><Modal.Title>{name || "Practitioner"} availability</Modal.Title></Modal.Header>
    <Modal.Body><ParentBadge supplier organizationName={supplier.organizationName} />
      <p className="schedule-help">Availability offered to {organizationName || "this organization"}.</p>
      {query.isError ? <Alert severity="error" action={<Button onClick={() => query.refetch()}>Retry</Button>}>Could not load availability.</Alert> :
        query.isLoading ? <p role="status">Loading availability…</p> : <SchedulingCalendar key={date} initialDate={date} initialView="timeGridDay" extraViews="timeGridDay" readOnly
          onDatesSet={({ start }) => setDate(moment(start).tz(timeZone).format("YYYY-MM-DD"))}
          timeZone={timeZone} events={buildCalendarEvents({ availability: data.availability || [], blocks: occupied, categories })} onEventClick={() => {}} />}
    </Modal.Body>
  </Modal>;
}
